import { render, staticRenderFns } from "./varieties.vue?vue&type=template&id=313d36b0&scoped=true"
import script from "./varieties.vue?vue&type=script&lang=js"
export * from "./varieties.vue?vue&type=script&lang=js"
import style0 from "./varieties.vue?vue&type=style&index=0&id=313d36b0&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "313d36b0",
  null
  
)

export default component.exports